import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, BANKS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allBank',
  url: `${BANKS_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
